<template>
  <div class="card">
    <div class="card-header">
      <h2 class="card-header-title">Création d'un geofence</h2>
    </div>
    <form class="card-content" @submit.prevent="submit">
      <div class="columns is-multiline">
        <name-field
          :name.sync="fields.name.value"
          class="column is-full-mobile"
          @error="fields.name.error = $event"
        />
        <category-field
          class="column is-full-mobile"
          :live-categories="liveCategories"
          :live-category-ids.sync="fields.liveCategoryIds.value"
        />
      </div>
      <div class="columns is-multiline">
        <tracker-interval-field
          label="Événement d'entrée*"
          message="Modifie l'intervalle des trackers entrant dans la zone"
          :tracker-interval.sync="fields.inTrackerInterval.value"
          :error-message="inTrackerIntervalErrorMessage"
          class="column is-full-mobile"
          @error="fields.inTrackerInterval.error = $event"
        />
      </div>
      <div class="columns is-multiline">
        <location-field
          class="column"
          :coordinate-format="coordinateFormat"
          :location.sync="fields.location.value"
          @error="fields.location.error = $event"
          @update:location="$emit('update:location', $event)"
        />
        <radius-field
          class="column is-full-mobile"
          :radius.sync="fields.radius.value"
          @error="fields.radius.error = $event"
          @update:radius="$emit('update:radius', $event)"
        />
      </div>
      <b-field class="buttons">
        <b-button
          :disabled="loading || error"
          :loading="loading"
          label="Ajouter"
          native-type="submit"
          type="is-primary"
        />
        <b-button type="is-danger" label="Annuler" @click="$emit('cancel')" />
      </b-field>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import CategoryField from './FormField/CategoryField.vue'
import LocationField from './FormField/LocationField.vue'
import NameField from './FormField/NameField.vue'
import RadiusField from './FormField/RadiusField.vue'
import TrackerIntervalField from './FormField/TrackerIntervalField.vue'

export default {
  name: 'AddForm',

  components: {
    CategoryField,
    LocationField,
    NameField,
    RadiusField,
    TrackerIntervalField,
  },

  props: {
    liveStageId: {
      type: String,
      required: true,
    },
    radius: {
      type: Number,
      required: true,
    },
    location: {
      type: Array,
      required: true,
    },
    coordinateFormat: {
      type: String,
      required: true,
    },
    liveCategories: {
      type: Array,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      fields: {
        location: {
          value: this.location,
          error: false,
        },
        radius: {
          value: this.radius,
          error: false,
        },
        inTrackerInterval: {
          value: null,
          error: true,
        },
        name: {
          value: null,
          error: true,
        },
        liveCategoryIds: {
          value: [],
        },
      },
    }
  },

  watch: {
    radius(newVal) {
      this.fields.radius.value = newVal
    },

    location(newVal) {
      this.fields.location.value = newVal
    },
  },

  computed: {
    inTrackerIntervalErrorMessage() {
      return !this.fields.inTrackerInterval.value ? "l'événement est requis" : null
    },

    error() {
      return Object.values(this.fields).find((field) => field.error === true)
    },
  },

  methods: {
    ...mapActions('ui', ['addToastMessage']),

    async submit() {
      this.loading = true

      try {
        const liveStageGeofence = await this.$services.liveTrackerGeofenceService.create({
          liveStageId: this.liveStageId,
          location: {
            latitude: this.fields.location.value[0],
            longitude: this.fields.location.value[1],
          },
          radius: this.fields.radius.value,
          inTrackerInterval: this.fields.inTrackerInterval.value,
          name: this.fields.name.value,
          liveCategoryIds: this.fields.liveCategoryIds.value,
        })

        this.$emit('create', liveStageGeofence)

        this.addToastMessage({
          text: `Le geofence "${liveStageGeofence.name}" a été créé.`,
          type: 'is-success',
        })
      } catch (err) {
        this.addToastMessage({
          text: err.message ?? `La création du geofence a échouée.`,
          type: 'is-danger',
        })
        console.error(err)
      }

      this.loading = false
    },
  },
}
</script>
